module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qBlxxb/Images/cover.jpg?1685327317428",
      "alt": "This image is the cover for the book Pioggia, Le regole del gioco"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pioggia, Le regole del gioco\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Seguito di Le regole del gioco")])])]), _c('p', [_vm._v("Sono ormai due anni che Brandon Stewart e Dustin Walker stanno insieme, da quella fatidica partita a biliardo che li ha fatti conoscere. Non è stato facile, per Dustin, fare coming out con la propria omofobica famiglia e ammettere i propri sentimenti per Brandon, ma ora i due progettano di sposarsi. Finché il fratello di Dustin, Tristan, non si rifà vivo sperando di riallacciare i rapporti, e Brandon incomincia a chiedersi se non ci sia un modo anche per lui di far pace col proprio fratello. Sono sedici anni che Brandon non vede Russell: sarà bastato un silenzio così lungo a rimarginare le ferite?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L.A. Witt, Martina Nealli\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0